import React from 'react';
import { motion } from 'framer-motion';
export function HeroImage() {
  return <motion.figure initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 1,
    delay: 0.2
  }} className="max-w-4xl mx-auto mb-12" data-id="element-52">
      <div className="relative aspect-[16/9] sm:aspect-[21/9] overflow-hidden bg-gray-100" data-id="element-53">
        <img src="https://images.unsplash.com/photo-1515377905703-c4788e51af15?q=80&w=2000&auto=format&fit=crop" alt="Mujer de 45 años con piel radiante" className="w-full h-full object-cover object-top" data-id="element-54" />
      </div>
      <figcaption className="text-center mt-3 px-4" data-id="element-55">
        <span className="font-serif italic text-sm text-gray-600" data-id="element-56">
          Estudios recientes demuestran que la edad biológica de la piel puede
          revertirse sin intervenciones quirúrgicas.
        </span>
      </figcaption>
    </motion.figure>;
}